import axios from "axios";
import API_PATH from "./apiPath";

// export const api_url = "https://scrapbackend.pikeazy.in";
// export const api_url = "https://scrapbackend.pikeazy.in";
// export const api_url = "http://localhost:5000";
export const api_url = 'https://scrapbackend.pikeazy.in';

export async function AdminLogin(data) {
  return axios.post(api_url + API_PATH.AdminLogin, data);
}

export async function WelcomeScreenAPI(page, itemsPerPage, token) {
  return axios.get(
    api_url +
    API_PATH.WelcomeScreen +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function DeleteByEmailId(email, token) {
  return axios.delete(api_url + API_PATH.DeleteByEmailId + email, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function CreateProductCategory(formData, token) {
  return axios.post(api_url + API_PATH.AddProductCategory, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetProductStatus(token) {
  return axios.get(api_url + API_PATH.ProductStatus, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function GetPageNumber(token) {
  return axios.get(api_url + API_PATH.Pagenumber, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetWedgetTitle(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.wedgettitle +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
export async function getAllTags(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.getAllTags +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
export async function getAllnotification(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.getAllnotification +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
export async function Getblinkit(queryParams, token) {
  // return axios.get(
  //   api_url +
  //   API_PATH.Getblinkit +
  //   "?page=" +
  //   page +
  //   "&itemsPerPage=" +
  //   itemsPerPage +
  //   "&search=" +
  //   search +
  //   "&startDate=" +
  //   startDate +
  //   "&endDate=" +
  //   endDate +
  //   {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //   }
  // )
  console.log("queryParams", queryParams)
  return axios.get(api_url + API_PATH.Getblinkit, {
    params: queryParams, // Automatically appends query parameters to the URL
    headers: {
      Authorization: `Bearer ${token}` // Adds Authorization header
    }
  });
}
export async function getStoreClicks(queryParams, token) {
  // return axios.get(
  //   api_url +
  //   API_PATH.Getblinkit +
  //   "?page=" +
  //   page +
  //   "&itemsPerPage=" +
  //   itemsPerPage +
  //   "&search=" +
  //   search +
  //   "&startDate=" +
  //   startDate +
  //   "&endDate=" +
  //   endDate +
  //   {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //   }
  // )

  console.log("queryParams>>>", queryParams)
  return axios.get(api_url + API_PATH.getStoreClicks, {
    params: queryParams, // Automatically appends query parameters to the URL
    headers: {
      Authorization: `Bearer ${token}` // Adds Authorization header
    }
  });
}

export async function getBestdealsClicks(queryParams, token) {

  // console.log("queryParams????", queryParams)
  return axios.get(api_url + API_PATH.getBestdealsClicks, {
    params: queryParams, // Automatically appends query parameters to the URL
    headers: {
      Authorization: `Bearer ${token}` // Adds Authorization header
    }
  });
}

export async function getBestDealDetails(queryParams, token) {

  // console.log("queryParams????", queryParams)
  return axios.get(api_url + API_PATH.getBestdealsClicks, {
    params: queryParams, // Automatically appends query parameters to the URL
    headers: {
      Authorization: `Bearer ${token}` // Adds Authorization header
    }
  });
}

export async function getallPincode(queryParams, token) {

  // console.log("queryParams????", queryParams)
  return axios.get(api_url + API_PATH.getallpincode, {
    // params: queryParams, // Automatically appends query parameters to the URL
    headers: {
      Authorization: `Bearer ${token}` // Adds Authorization header
    }
  });
}

export async function Getbigbasket(queryParams, token) {
  // return axios.get(
  //   api_url +
  //   API_PATH.Getblinkit +
  //   "?page=" +
  //   page +
  //   "&itemsPerPage=" +
  //   itemsPerPage +
  //   "&search=" +
  //   search +
  //   "&startDate=" +
  //   startDate +
  //   "&endDate=" +
  //   endDate +
  //   {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //   }
  // )
  console.log("queryParams", queryParams)
  return axios.get(api_url + API_PATH.Getbigbasket, {
    params: queryParams, // Automatically appends query parameters to the URL
    headers: {
      Authorization: `Bearer ${token}` // Adds Authorization header
    }
  });
}
export async function GetWedgetOptionwithbanner(token) {
  return axios.get(api_url + API_PATH.wedgettitle, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function getBrand(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.getBrand +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
export async function GetEmployeeStatus(token) {
  return axios.get(api_url + API_PATH.EmployeeStatus, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetEmployeeRole(token) {
  return axios.get(api_url + API_PATH.EmployeeRole, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function CreateEmployee(data, token) {
  return axios.post(api_url + API_PATH.AddEmployee, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function CreateTag(data, token) {
  return axios.post(api_url + API_PATH.Addtag, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function CreateNotification(data, token) {
  return axios.post(api_url + API_PATH.createnotification, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function CreateMedia(formData, token) {
  return axios.post(api_url + API_PATH.AddMedia, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function CreateBanner(formData, token) {
  return axios.post(api_url + API_PATH.AddBanner, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function CreateStore(formData, token) {
  return axios.post(api_url + API_PATH.AddStore, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function CreateBrand(data, token) {
  console.log("data", data);
  return axios.post(api_url + API_PATH.AddBrand, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function CreateWidget(data, token) {
  console.log("data", data);
  return axios.post(api_url + API_PATH.AddWidget, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function CreateModule(data, token) {
  return axios.post(api_url + API_PATH.AddModule, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetProductCatWithoutPage(token) {
  return axios.get(api_url + API_PATH.GetProductCategoryWithoutPage, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function GetPincodeProduct(
  // page,
  // itemsPerPage,
  search,
  token,
  categoryids,
  subcategoryid
) {
  const queryParams = new URLSearchParams({
    // page: page,
    // itemsPerPage: itemsPerPage,
    search: search,
    categoryids: categoryids,
    ...(typeof subcategoryid !== "undefined" && {
      subcategoryid: subcategoryid,
    }),
  }).toString();
  console.log(
    "???????????????????????????????////////",
    search,
    token,
    categoryids,
    subcategoryid
  );
  return axios.get(`${api_url}${API_PATH.GetPincodeproduct}?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function GetProductSubCatWithoutPage(token) {
  return axios.get(api_url + API_PATH.GetProductSubCategoryWithoutPage, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function getallbrandnamewithoutpagination(token) {
  return axios.get(api_url + API_PATH.getallbrandnamewithoutpagination, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function getalltagwithoutpagination(token) {
  return axios.get(api_url + API_PATH.getalltagwithoutpagination, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function CreateProduct(data, token) {
  return axios.post(api_url + API_PATH.AddProduct, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function CreateProfile(data, token) {
  return axios.post(api_url + API_PATH.AddProfile, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetAllModuleWithoutPage(token) {
  return axios.get(api_url + API_PATH.GetAllModules, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetModuleMode(token) {
  return axios.get(api_url + API_PATH.GetModuleMode, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetAllProfile(token) {
  return axios.get(api_url + API_PATH.GetAllProfile, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetAllRole(token) {
  return axios.get(api_url + API_PATH.GetAllRole, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetRoleTree(token) {
  return axios.get(api_url + API_PATH.GetRoleTree, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function CreateRole(data, token) {
  return axios.post(api_url + API_PATH.AddRole, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function CreateSlider(data, token) {
  return axios.post(api_url + API_PATH.AddSlider, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetAllMedia(token) {
  return axios.get(api_url + API_PATH.GetAllMedia, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetCategoryImage(path) {
  return axios.get(api_url + API_PATH.GetCategoryImage + path);
}

export async function GetSubCategoryImage(path) {
  return axios.get(api_url + API_PATH.GetSubCategoryImage + path);
}

export async function CreateSubCategory(formData, token) {
  return axios.post(api_url + API_PATH.AddSubCategory, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetCategoryBySearch(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.GetCategory +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function DeleteCategory(categoryid, token) {
  return axios.delete(api_url + API_PATH.DeleteCategory + categoryid, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetCustomerBySearch(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.GetCustomer +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function DeleteCustomer(phonenumber, token) {
  return axios.delete(api_url + API_PATH.DeleteCustomer + phonenumber, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetCategoryById(categoryid, token) {
  return axios.get(api_url + API_PATH.GetCategoryById + categoryid, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function EditProductCategory(formData, token) {
  return axios.put(api_url + API_PATH.EditCategory, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function EditCustomerAPI(data, token) {
  return axios.put(api_url + API_PATH.GetCustomer, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetCustomerByPhone(phone, token) {
  return axios.get(api_url + API_PATH.GetCustomerByPhone + phone, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetCustomerCity(token) {
  return axios.get(api_url + API_PATH.GetCustomerCity, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetCustomerState(token) {
  return axios.get(api_url + API_PATH.GetCustomerState, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetCustomerCountry(token) {
  return axios.get(api_url + API_PATH.GetCustomerCountry, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetCustomerStatus(token) {
  return axios.get(api_url + API_PATH.GetCustomerStatus, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetCustomerRole(token) {
  return axios.get(api_url + API_PATH.GetCustomerRole, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetEmployeByEmail(email, token) {
  return axios.get(api_url + API_PATH.GetEmployeByEmail + email, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function EditEmployeeAPI(data, token) {
  return axios.put(api_url + API_PATH.AddEmployee, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function EditWedgetAPI(data, token) {
  console.log("data>>>>>>", data);
  return axios.post(api_url + API_PATH.UpdateWedget, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function updateProductsInWidget(data, token) {
  console.log("data>>>>>>", data);
  return axios.post(api_url + API_PATH.updateProductsInWidget, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function EditWedgetProduct(data, token) {
  console.log("UpdateWedgetProduct>>>>>>", data);
  return axios.post(api_url + API_PATH.UpdateWedgetProduct, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function EditBrandByAPI(data, token) {
  console.log("data>>>>>>", data);
  return axios.post(api_url + API_PATH.Updatbrand, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function EditTagAPI(data, token) {
  console.log("id, data,", data,);
  return axios.post(api_url + API_PATH.UpdatTag, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function EditNotificationAPI(data, token) {
  console.log("id, data,", data,);
  return axios.put(api_url + API_PATH.EditNotification, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function GetMediaById(id, token) {
  return axios.get(api_url + API_PATH.GetmediaById + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function GetBannerById(id, token) {
  return axios.get(api_url + API_PATH.GetBannerById + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetstoreById(id, token) {
  return axios.get(api_url + API_PATH.GetstoreById + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetwidgetById(id, token) {
  return axios.get(api_url + API_PATH.GetwedgetById + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function GetwidgetId(id, token) {
  return axios.get(api_url + API_PATH.GetWidgetId + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function GetBrandById(id, token) {
  return axios.get(api_url + API_PATH.GetBrandById + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function EditMediaAPI(data, token) {
  return axios.put(api_url + API_PATH.AddMedia, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
// export async function EditMediaAPI(data, token) {
//   return axios.put(api_url + API_PATH.AddMedia, data, {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });
// }
export async function EditBannerAPI(id, data, token) {
  return axios.put(api_url + API_PATH.Editbanner + `/${id}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function EditStoreAPI(data, token) {
  console.log("edit data here", data);
  return axios.put(api_url + API_PATH.EditStore, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetModuleById(id, token) {
  return axios.get(api_url + API_PATH.GetModuleById + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function UpdateModule(data, token) {
  return axios.put(api_url + API_PATH.EditModule, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetProductById(id, token) {
  return axios.get(api_url + API_PATH.GetProductById + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function UpdateProduct(data, token) {
  return axios.put(api_url + API_PATH.AddProduct, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetProfileById(id, token) {
  return axios.get(api_url + API_PATH.GetProfileById + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function UpdateProfile(data, token) {
  return axios.put(api_url + API_PATH.EditProfile, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetRoleById(id, token) {
  return axios.get(api_url + API_PATH.GetRoleById + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function UpdateRole(data, token) {
  return axios.put(api_url + API_PATH.AddRole, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetValidParentsRole(id, token) {
  return axios.get(api_url + API_PATH.GetValidParentsRole + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function UpdateSlider(data, token) {
  return axios.put(api_url + API_PATH.AddSlider, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetSliderById(id, token) {
  return axios.get(api_url + API_PATH.GetSliderById + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetSubCategoryById(id, token) {
  return axios.get(api_url + API_PATH.GetProductSubCategoryById + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function UpdateSubCategory(data, token) {
  return axios.put(api_url + API_PATH.AddSubCategory, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function DeleteEmployee(email, token) {
  return axios.delete(api_url + API_PATH.DeleteEmployee + email, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetEmployePage(page, itemsPerPage, token) {
  return axios.get(
    api_url +
    API_PATH.AddEmployee +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function GetFeedbackPage(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.GetFeedback +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function GetStore(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.GetStore +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function ForgetPassword(data) {
  return axios.post(api_url + API_PATH.ForgetPassword, data);
}

export async function GetMediaPage(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.AddMedia +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
export async function getBanner(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.Getbanner +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function DeleteMedia(id, token) {
  return axios.delete(api_url + API_PATH.DeleteMedia + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function DeleteBanner(id, token) {
  return axios.delete(api_url + API_PATH.DeleteBanner + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function DeleteTag(id, token) {
  return axios.delete(api_url + API_PATH.DeleteTag + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function getByIdTag(id, token) {
  return axios.get(api_url + API_PATH.getByIdTag + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function getByIdNotification(id, token) {
  return axios.get(api_url + API_PATH.getByIdNotification + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function DeleteNotification(id, token) {
  console.log('id', id)
  return axios.delete(api_url + API_PATH.DeleteNotification + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function Deletewidget(id, token) {
  return axios.delete(api_url + API_PATH.Deletewidget + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetModulePage(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.GetModulePage +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function DeleteModule(id, token) {
  return axios.delete(api_url + API_PATH.DeleteModule + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetOrderPage(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.GetOrder +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function GetProductPage(
  page,
  itemsPerPage,
  search,
  token,
  categoryids,
  subcategoryid
) {
  const queryParams = new URLSearchParams({
    page: page,
    itemsPerPage: itemsPerPage,
    search: search,
    categoryids: categoryids,
    ...(typeof subcategoryid !== "undefined" && {
      subcategoryid: subcategoryid,
    }),
  }).toString();

  return axios.get(`${api_url}${API_PATH.AddProduct}?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function DeleteProduct(id, token) {
  return axios.delete(api_url + API_PATH.DeleteProduct + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetProfilePage(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.GetProfilePage +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function DeleteProfile(id, token) {
  return axios.delete(api_url + API_PATH.DeleteProfile + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function CreateAccount(data) {
  return axios.post(api_url + API_PATH.WelcomeScreen, data);
}

export async function DeleteRole(id, token) {
  return axios.delete(api_url + API_PATH.AddRole + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetRolePage(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.RolePage +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function GetSliderPage(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.AddSlider +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function DeleteSlider(id, token) {
  return axios.delete(api_url + API_PATH.DeleteSlider + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function DeleteStore(id, token) {
  return axios.delete(api_url + API_PATH.DeleteStore + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function DeleteBrand(id, token) {
  console.log("id", id);

  return axios.delete(api_url + API_PATH.DeleteBrand + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function GetSubcategoryPage(page, itemsPerPage, search, token) {
  return axios.get(
    api_url +
    API_PATH.AddSubCategory +
    "?page=" +
    page +
    "&itemsPerPage=" +
    itemsPerPage +
    "&search=" +
    search,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function DeleteSubCategory(id, token) {
  return axios.delete(api_url + API_PATH.DeleteSubCategory + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetFeedbackById(id, token) {
  return axios.get(api_url + API_PATH.GetFeedbackById + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function GetOrderById(id, token) {
  return axios.get(api_url + API_PATH.GetOrderById + id, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function GetexoticProducts() {
  return axios.get(api_url + API_PATH.GetexoticProducts);
}
export async function LastMinuteAddons() {
  return axios.get(api_url + API_PATH.LastMinuteAddons);
}
export async function GetBestsellers() {
  return axios.get(api_url + API_PATH.Bestsellers);
}
export async function GetIShotDeals() {
  return axios.get(api_url + API_PATH.GetIShotDeals);
}
export async function GetIsTrendingInYourArea() {
  return axios.get(api_url + API_PATH.GetIsTrendingInYourArea);
}
export async function GetIsTrendingOffers() {
  return axios.get(api_url + API_PATH.GetIsTrendingOffers);
}
export async function GetIsHealthySnacking() {
  return axios.get(api_url + API_PATH.GetIsHealthySnacking);
}
